// §61 Radar heat / newest headline / open roles for prospects linked to a Radar company.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { companyKey } from "@/components/rcc/li/CompanyGroups";

const newest = (sigs) => sigs.sort((a, b) => new Date(b.published_at || b.created_at || 0) - new Date(a.published_at || a.created_at || 0))[0];

export const useRadarIndex = (items) => {
  const ids = [...new Set(items.map((p) => p.radar_company_id).filter(Boolean))].sort().join(",");
  const [idx, setIdx] = useState({});
  useEffect(() => {
    if (!ids) return;
    let live = true;
    Promise.all([
      api.get("/admin/rcc/radar/heatmap?days=30").then((r) => r.data?.items || []).catch(() => []),
      api.get("/admin/rcc/signals?limit=500").then((r) => r.data?.items || []).catch(() => []),
    ]).then(([heat, sigs]) => {
      if (!live) return;
      const byName = sigs.reduce((m, s) => { const k = companyKey(s.company_name); (m[k] ||= []).push(s); return m; }, {});
      const byId = sigs.reduce((m, s) => { if (s.company_id) (m[s.company_id] ||= []).push(s); return m; }, {});
      const out = {};
      heat.forEach((c) => { const s = newest([...(byId[c.id] || []), ...(byName[companyKey(c.name)] || [])]); out[c.id] = { heat: c.heat, open_roles: c.open_roles, headline: s && { title: s.title || s.description, url: s.source_url, date: s.published_at || s.created_at } }; });
      setIdx(out);
    });
    return () => { live = false; };
  }, [ids]);
  return idx;
};

// Backend fields on the prospect (p.radar) win over the browser-side index.
export const radarFor = (p, idx) => {
  if (!p.radar_company_id) return null;
  const b = p.radar || {};
  const f = idx[p.radar_company_id] || {};
  const n = b.latest_news;
  return { heat: b.heat ?? f.heat, open_roles: b.open_roles ?? f.open_roles, headline: n ? { title: n.title, url: n.url, date: n.published_at || n.date } : f.headline };
};
